import { Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import DynamicTranscriptText from '~/pages/CallAnalytics/Transcription/DynamicTranscriptText'
import TranscriptEntryHeader from '~/pages/CallAnalytics/Transcription/TranscriptEntryHeader'
import { TranscriptEntry } from '~/types/CallTranscript'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const TranscriptionEntryWrapper = styled.div<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-wrap: break-word;
  padding: 12px;
  background-color: ${(props) =>
    props.$isActive
      ? 'var(--chakra-colors-bg-muted)'
      : 'var(--chakra-colors-bg-panel)'};
  border-radius: 4px;
  &:hover {
    background-color: var(--chakra-colors-bg-muted);
  }
  margin-bottom: 2px;
`

const StaticTranscriptText = styled.span`
  color: var(--chakra-colors-fg-default);
`

interface TranscriptionEntryProps {
  index: number
  transcriptEntry: TranscriptEntry
  transcriptName: string
  childRefFunc?: (ref: HTMLDivElement | null) => void
  isActive?: boolean
  isWaiting?: boolean
  isPlaying: boolean
}

const TranscriptionEntry = ({
  index,
  transcriptEntry,
  transcriptName,
  childRefFunc,
  isActive = true,
  isPlaying,
}: TranscriptionEntryProps) => {
  const { t } = useTranslation()
  const [hovered, setHovered] = useState(false)

  const getPersonId = (agentName: string) => {
    switch (agentName) {
      case 'AGENT':
        return 0
      case 'CUSTOMER':
        return 1
      default:
        return 2
    }
  }

  const personId = getPersonId(transcriptEntry.ParticipantRole)
  return (
    <TranscriptionEntryWrapper
      ref={(r) => childRefFunc?.(r)}
      $isActive={isActive}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <TranscriptEntryHeader
        transcriptId={transcriptName}
        personId={personId}
        personName={
          transcriptEntry.ParticipantRole === 'AGENT'
            ? t('callAnalytics.transcript.office', 'Office')
            : t('callAnalytics.transcript.patient', 'Patient')
        }
        beginOffsetMillis={transcriptEntry.BeginOffsetMillis}
        isActive={isActive}
        isHovered={hovered}
        isPlaying={isPlaying}
      />
      <Text
        {...textStyles[textStyleKeys.Body2]}
        paddingLeft="64px"
        textAlign="justify"
      >
        {isActive ? (
          <DynamicTranscriptText
            index={index}
            transcriptEntry={transcriptEntry}
          />
        ) : (
          <StaticTranscriptText>{transcriptEntry.Content}</StaticTranscriptText>
        )}
      </Text>
    </TranscriptionEntryWrapper>
  )
}

export default TranscriptionEntry
